"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[740],{

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 25343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15722);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var CONFIG = {
    1: {
        message: "Foarte nesigura",
        backgroundColor: "bg-[#C00033]"
    },
    2: {
        message: "Nesigura",
        backgroundColor: "bg-[#FD0245]"
    },
    3: {
        message: "Siguranta medie",
        backgroundColor: "bg-[#F8B500]"
    },
    // 4: {
    //   message: "Sigura",
    //   backgroundColor: "bg-[#61DC00]",
    // },
    4: {
        message: "Foarte sigura",
        backgroundColor: "bg-[#319D10]"
    }
};
var CheckIcon = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "text-[#319D10] text-[18px] font-medium",
        children: "✓"
    });
};
var CrossIcon = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "text-red-brand text-[18px] font-semibold",
        children: "✕"
    });
};
var PasswordComplexity = function(param1) {
    var password = param1.password;
    var ref = (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getPasswordComplexity */ .QL)(password), score = ref.score, cases = ref.cases;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full mb-[2px] flex space-x-[10px]",
                children: Object.entries(CONFIG).map(function(param, index) {
                    var _param = _slicedToArray(param, 2), complexity = _param[0], config = _param[1];
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[4px] rounded-[24px] w-[25%] ".concat(score >= complexity ? config.backgroundColor : "bg-[#D8D8D8]")
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[14px] font-medium mt-[6px]",
                children: "Parola trebuie sa contina:"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "text-[14px] text-[#979797] list-disc ml-[15px]",
                children: Object.values(cases).map(function(caseItem, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            caseItem.description,
                            " ",
                            caseItem.isMet ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckIcon, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CrossIcon, {})
                        ]
                    }, index);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PasswordComplexity);


/***/ }),

/***/ 77485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26209);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66688);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11752);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var _lib_validations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38294);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58833);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52077);
/* harmony import */ var _store_user_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49865);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27173);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])(), settings = ref.publicRuntimeConfig.settings;
var LoginForm = function(props) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), smsData = ref1[0], setSmsData = ref1[1];
    var loginAction = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
            var res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return props.userLogin(values, props.redirect || null, true, props.location);
                    case 2:
                        res = _ctx.sent;
                        if (res && !res.token && res.data) {
                            setSmsData(res.data);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loginAction(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var postSmsAction = function(values) {
        return props.userLogin({
            sent_code: values.sent_code,
            telephone: smsData.telephone,
            id: smsData.id,
            customer_id: smsData.customer_id
        }, props.redirect || null, true, props.location);
    };
    if (smsData) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
                    onSubmit: postSmsAction,
                    render: function(param) {
                        var handleSubmit = param.handleSubmit, submitting = param.submitting;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "text-sm",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                        name: "sent_code",
                                        type: "text",
                                        label: "Cod SMS",
                                        component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                        autoComplete: "one-time-code",
                                        inputClassName: "max-w-fulli",
                                        required: true,
                                        validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isRequired */ .q9)())
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        title: "Verifica",
                                        display: "block",
                                        variant: "primary",
                                        type: "submit",
                                        disabled: submitting
                                    })
                                })
                            ]
                        });
                    }
                }, "ACCOUNT_LOGIN_FORM_SMS"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "text-center text-sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "text-red-brand hover:text-bleu-hover underline",
                        onClick: function() {
                            setSmsData(null);
                        },
                        children: "Renunta"
                    })
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
                onSubmit: loginAction,
                render: function(param) {
                    var handleSubmit = param.handleSubmit, submitting = param.submitting;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "email",
                                    type: "email",
                                    label: "Introdu adresa de email",
                                    autoComplete: "username",
                                    component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                    inputClassName: "max-w-fulli",
                                    required: true,
                                    placeholder: "Introdu adresa de email",
                                    validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isEmail */ .Jh)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .hasMaxLength */ .aG)(80))
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "password",
                                    label: "Parola",
                                    type: "password",
                                    autoComplete: "current-password",
                                    component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                    inputClassName: "max-w-fulli",
                                    required: true,
                                    placeholder: "Introdu parola",
                                    validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isRequired */ .q9)()
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    title: "Logheaza-te in cont",
                                    display: "block",
                                    variant: "primary",
                                    type: "submit",
                                    disabled: submitting
                                })
                            })
                        ]
                    });
                }
            }, "ACCOUNT_LOGIN_FORM"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center text-sm",
                children: props.recoverPassInModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "text-red-brand hover:text-bleu-hover underline",
                    onClick: function() {
                        props.removeModal();
                        props.addModal(props.resetPassModalId);
                    },
                    children: "Recuperare parola"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_6__["default"], {
                    href: "".concat(settings.baseUrl, "/cont/parola-uitata/"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        className: "text-red-brand hover:text-bleu-hover underline",
                        children: "Ai uitat parola?"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(null, {
    userLogin: _store_user_actions__WEBPACK_IMPORTED_MODULE_10__/* .userLogin */ .n$,
    addModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_11__/* .addModal */ .Y_,
    removeModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_11__/* .removeModal */ .a_
})(LoginForm));


/***/ }),

/***/ 84266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26209);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66688);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var _lib_validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38294);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58833);
/* harmony import */ var _components_Form_PhoneField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48626);
/* harmony import */ var _components_Form_Checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71662);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52077);
/* harmony import */ var _lib_phoneNumber__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58475);
/* harmony import */ var _store_user_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49865);
/* harmony import */ var _components_PasswordComplexity__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25343);












function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _settings = _publicRuntimeConfig.settings, baseUrl = _settings.baseUrl, websiteName = _settings.websiteName, websiteTitle = _publicRuntimeConfig.content.websiteTitle;
var RegisterForm = function(props) {
    var _hasGrid = props.hasGrid, hasGrid = _hasGrid === void 0 ? false : _hasGrid;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
        initialValues: {
            telephone_country_code: _lib_phoneNumber__WEBPACK_IMPORTED_MODULE_11__/* .ROMANIA_COUNTRY_CODE */ .Ct
        },
        onSubmit: function(values) {
            var wire = (0,_lib_phoneNumber__WEBPACK_IMPORTED_MODULE_11__/* .phoneToWire */ .Xj)(values.telephone, values.telephone_country_code);
            return props.userRegister(_objectSpread({}, values, {
                telephone: wire.telephone,
                telephone_country_code: wire.telephone_country_code
            }), props.redirect);
        },
        validate: function(values) {
            var errors = {};
            if (values.password && values.password_confirm && values.password !== values.password_confirm) {
                errors.password_confirm = "Trebuie utilizata aceeasi parola.";
            }
            return errors;
        },
        render: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting, values = param.values;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubmit,
                noValidate: true,
                autoComplete: "false",
                className: "text-sm ".concat(hasGrid ? "flex flex-wrap -mx-4" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full md:w-1/2 px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            name: "first_name",
                            label: "Prenume",
                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                            autoCorrect: "off",
                            inputClassName: "max-w-fulli",
                            required: true,
                            validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isAlphaNumeric */ .bJ)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMaxLength */ .aG)(60), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMinLength */ .vd)(3))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full md:w-1/2 px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            name: "last_name",
                            label: "Nume",
                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                            autoCorrect: "off",
                            inputClassName: "max-w-fulli",
                            required: true,
                            validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isAlphaNumeric */ .bJ)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMaxLength */ .aG)(60), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMinLength */ .vd)(3))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full md:w-1/2 px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            name: "email",
                            type: "email",
                            label: "Introdu adresa de email",
                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                            inputClassName: "max-w-fulli",
                            autoComplete: "off",
                            required: true,
                            validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isEmail */ .Jh)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMaxLength */ .aG)(80), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMinLength */ .vd)(5))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full md:w-1/2 px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_PhoneField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            id: "register_telephone",
                            accepts: _components_Form_PhoneField__WEBPACK_IMPORTED_MODULE_6__/* .PHONE_ACCEPTS.FIXED_OR_MOBILE */ .k.FIXED_OR_MOBILE,
                            label: "Numar de telefon",
                            inputClassName: "max-w-fulli",
                            autoCorrect: "off",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full md:w-1/2 px-4" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                name: "password",
                                label: "Parola",
                                type: "password",
                                autoComplete: "new-password",
                                inputClassName: "max-w-fulli",
                                component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                                required: true,
                                validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMinLength */ .vd)(6))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-[7px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PasswordComplexity__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    password: values.password
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full md:w-1/2 px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            name: "password_confirm",
                            label: "Confirma parola",
                            type: "password",
                            autoComplete: "new-password",
                            inputClassName: "max-w-fulli",
                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                            required: true,
                            // TODO: Add password requirements
                            validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .hasMinLength */ .vd)(6))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            name: "agree_terms",
                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    "Sunt de acord cu",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "".concat(baseUrl, "/suport-clienti/informatii-generale-termeni-si-conditii/"),
                                        title: "Termenii si conditiile",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-red-brand font-semibold",
                                        children: "Termenii si conditiile"
                                    }),
                                    " ",
                                    "de utilizare a site-ului ".concat(websiteName, ".ro")
                                ]
                            }),
                            type: "checkbox",
                            component: _components_Form_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                            required: true,
                            validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_4__/* .isRequired */ .q9)()
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full px-4" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            name: "check1",
                            component: _components_Form_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                            label: "Aboneaza-te la newsletter-ul ".concat(websiteTitle, " pentru a primi cele mai bune oferte!"),
                            type: "checkbox"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 ".concat(hasGrid ? "w-full px-4" : ""),
                        children: [
                            "Informatie - Pentru informatii suplimentare, va rugam sa accesati pagina",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "".concat(baseUrl, "/protectia-datelor-caracter-personal/pag/"),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-red-brand font-semibold",
                                children: "Protectia Datelor cu Caracter Personal"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4 lg:mb-0 ".concat(hasGrid ? "w-full px-4 text-center" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            title: "Inregistrare",
                            display: hasGrid ? "inline" : "block",
                            variant: "primary",
                            type: "submit",
                            disabled: submitting
                        })
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(null, {
    userRegister: _store_user_actions__WEBPACK_IMPORTED_MODULE_9__/* .userRegister */ .N$
})(RegisterForm));


/***/ })

}]);